import { useEffect } from 'react';
import authService from '../services/auth';

const useTokenRefresh = () => {
  useEffect(() => {
    let refreshInterval;

    const startTokenRefresh = () => {
      // Refresh token every 20 minutes (before 24-hour expiry)
      refreshInterval = setInterval(async () => {
        if (authService.isAuthenticated()) {
          try {
            await authService.refreshAuthToken();
          } catch (error) {
            console.error('Token refresh failed:', error);
            // If refresh fails, logout user
            authService.logout();
            window.location.href = '/admin';
          }
        }
      }, 20 * 60 * 1000); // 20 minutes
    };

    if (authService.isAuthenticated()) {
      startTokenRefresh();
    }

    return () => {
      if (refreshInterval) {
        clearInterval(refreshInterval);
      }
    };
  }, []);
};

export default useTokenRefresh;